import type { Accept } from 'react-dropzone';

export const acceptFromTypes = (mediaTypes: string[]): Accept => (
  Object.fromEntries(mediaTypes.map(mediaType => [mediaType, []]))
);
